exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.popup-user-reset-password[data-v-2ca55217] {\n  border-radius: 15px;\n  background-color: rgba(255, 255, 255, .95);\n  height: 180px;\n  width: 50%;\n}\n.container-user-reset-password[data-v-2ca55217] {\n  margin: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ca55217","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/popups/user/CMUserResetPassword.vue
// module id = 1558
// module chunks = 2